import { ProductUIAppWindow } from '../product-ui-app-window/product-ui-app-window';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import { useProductUINSTranslation } from '../product-ui-ns-context';
import { ProductUISceneContainer, ProductUISceneLayer } from '../product-ui-scene-container/product-ui-scene-container';
import { TemplateSidebarStandard } from '../product-ui-sidebar/product-ui-sidebar-templates';
import { ProductUITaskAttributePill } from '../product-ui-task-attribute-pill/product-ui-task-attribute-pill';
import { TemplateTodayView } from '../product-ui-view/product-ui-view-templates';
import { QuickAdd } from '../quick-add/quick-add';
export function FreeProFeatures() {
  const {
    t
  } = useProductUINSTranslation();
  return <ProductUISceneContainer backgroundVariant="wave-one" data-sentry-element="ProductUISceneContainer" data-sentry-component="FreeProFeatures" data-sentry-source-file="free-pro-features.tsx">
            <ProductUISceneLayer position="modalOpenLeft" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="free-pro-features.tsx">
                <ProductUIAppWindow sidebar={<TemplateSidebarStandard />} view={<TemplateTodayView />} showOverlay data-sentry-element="ProductUIAppWindow" data-sentry-source-file="free-pro-features.tsx" />
            </ProductUISceneLayer>
            <ProductUISceneLayer position="center" data-sentry-element="ProductUISceneLayer" data-sentry-source-file="free-pro-features.tsx">
                <QuickAdd taskSection={<QuickAdd.TaskText>
                            <QuickAdd.Intent>
                                {t('sequence.freeProFeatures.happyHour')}
                            </QuickAdd.Intent>
                            <QuickAdd.Intent variant="highlight">
                                {t('sequence.freeProFeatures.thursAt6pm')}
                            </QuickAdd.Intent>
                            <QuickAdd.Intent variant="highlight">
                                {t('sequence.freeProFeatures.for2h')}
                            </QuickAdd.Intent>
                            <QuickAdd.Intent variant="highlight">
                                {t('sequence.freeProFeatures.!45mb')}
                            </QuickAdd.Intent>
                        </QuickAdd.TaskText>} attributeSection={<>
                            <ProductUITaskAttributePill variant="dueDateCustom" color="purple">
                                {t('sequence.freeProFeatures.thurs6to8pm')}
                            </ProductUITaskAttributePill>
                            <ProductUITaskAttributePill variant="reminderCustom">
                                {t('sequence.freeProFeatures.45MinsBefore')}
                            </ProductUITaskAttributePill>
                        </>} footerSection={<QuickAdd.FooterContainer>
                            <QuickAdd.FooterProjectButton variant="project" label={t('sequence.freeProFeatures.eveningActivities')} iconColor="orange" />
                            <QuickAdd.FooterSpacer />
                            <ProductUIButton className="addTaskButton" variant="primary" data-productui="cta">
                                {t('sequence.freeProFeatures.addTask')}
                            </ProductUIButton>
                        </QuickAdd.FooterContainer>} data-sentry-element="QuickAdd" data-sentry-source-file="free-pro-features.tsx" />
            </ProductUISceneLayer>
        </ProductUISceneContainer>;
}